module.exports = __webpack_public_path__ + "static/media/manOnTable.e77f43ca.svg";